import React from "react";
import Modal from "../../ui/Modal/Modal";
import TeaserEdit from "./TeaserEdit";

const TeaserEditModal = ({ match }) => {
  const onClose = () => {
    window.history.back();
  };

  return (
    <Modal className="modal-page-wrapper" onClose={onClose}>
      <TeaserEdit light match={match} isModal={true} onModalClose={onClose} />
    </Modal>
  );
};

export default TeaserEditModal;
